<form
  *ngIf="contactForm"
  (submit)="$event.preventDefault()"
  (keydown.enter)="$event.preventDefault()"
  class="field-dialog__content__scroll p-24"
  [ngClass]="{ 'with-disclaimer': isViewMode }"
  ngNoForm
  fusePerfectScrollbar
>
  <div
    *ngIf="!contactForm.get('emails')['controls'].length && !contactForm.get('phones').value.length"
    fxLayout="column"
    fxLayoutAlign="center center"
    class="p-24"
  >
    <p fxFlex="100" fxLayout="row">
      <mat-icon class="font-size-32">contacts</mat-icon>
    </p>
    <span class="h3 mt-10">
      {{ 'CONTACTS.NO_CONTACTS' | translate }}
    </span>
  </div>

  <div *ngIf="contactForm.get('emails')['controls'].length">
    <div
      *ngFor="
        let contactEmail of contactForm.get('emails')['controls'];
        index as index;
        first as isFirst;
        last as isLast
      "
    >
      <div class="mb-30" fxLayout="column" fxFlex="100">
        <div class="contact-form-field" fxLayout="row">
          <mat-form-field class="pr-4" appearance="legacy" fxFlex="40">
            <mat-label>{{ 'CONTACTS.EMAIL.ADDRESS' | translate }}</mat-label>
            <input
              id="contact-emails-{{ index }}"
              [formControl]="contactEmail.get('emailAddress')"
              matInput
              required
              autocomplete="email"
            />

            <mat-error *ngIf="contactEmail.get('emailAddress').hasError('required')">
              {{ 'CONTACTS.EMAIL.ERRORS.ADDRESS_REQUIRED' | translate }}
            </mat-error>
            <mat-error *ngIf="contactEmail.get('emailAddress').hasError('email')">
              {{ 'CONTACTS.EMAIL.ERRORS.ADDRESS_VALID' | translate }}
            </mat-error>
            <mat-error
              *ngIf="
                contactEmail.get('emailAddress').hasError('emailEmailAddressDuplicated') &&
                !contactEmail.get('emailAddress').hasError('required')
              "
            >
              {{ 'CONTACTS.EMAIL.ERRORS.ADDRESS_DUPLICATED' | translate }}
            </mat-error>
          </mat-form-field>

          <mat-form-field class="pr-3" appearance="legacy" fxFlex="28">
            <mat-label>{{ 'CONTACTS.EMAIL.TYPE' | translate }}</mat-label>
            <mat-select [formControl]="contactEmail.get('contactType')" required>
              <mat-option value="work">
                {{ 'CONTACTS.EMAIL.WORK' | translate }}
              </mat-option>
              <mat-option value="personal">
                {{ 'CONTACTS.EMAIL.PERSONAL' | translate }}
              </mat-option>
            </mat-select>

            <mat-error *ngIf="contactEmail.get('contactType').hasError('required')">
              {{ 'CONTACTS.EMAIL.ERRORS.TYPE_REQUIRED' | translate }}
            </mat-error>
          </mat-form-field>

          <mat-form-field class="pl-4" appearance="legacy" fxFlex="25">
            <mat-label> {{ 'CONTACTS.EMAIL.NAME' | translate }}</mat-label>
            <input id="contact-phones-{{ index }}" [formControl]="contactEmail.get('name')" matInput />
          </mat-form-field>

          <div *ngIf="!isViewMode" class="remove-contact-field" (click)="removeContactItem('emails', index)">
            <mat-icon>delete</mat-icon>
          </div>
        </div>

        <div class="mt-5" fxLayout="row">
          <mat-slide-toggle
            (change)="changePrimaryContactItem('emails', index)"
            [formControl]="contactEmail.get('primary')"
          >
            {{ 'CONTACTS.EMAIL.PRIMARY' | translate }}
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="!isViewMode && contactForm.get('emails')['controls'].length < 3"
    [ngClass]="{ 'add-more-contact-button': contactForm.get('emails')['controls'].length > 0 }"
    (click)="addNewContactItem('emails')"
    class="new-contact-button"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    matRipple
  >
    <div>
      <mat-icon class="new-contact-button-icon font-size-24">alternate_email</mat-icon>
      <p class="h4 new-contact-button-text">{{ 'CONTACTS.ADD_EMAIL' | translate }}</p>
    </div>
  </div>

  <mat-divider
    *ngIf="contactForm.get('emails')['controls'].length || contactForm.get('phones')['controls'].length"
    class="mb-20"
  ></mat-divider>

  <div *ngIf="contactForm.get('phones')['controls'].length">
    <div
      *ngFor="
        let contactPhone of contactForm.get('phones')['controls'];
        index as index;
        first as isFirst;
        last as isLast
      "
    >
      <div class="mb-30" fxLayout="column" fxFlex="100">
        <div class="contact-form-field" fxLayout="row">
          <mat-form-field class="pr-4" appearance="legacy" fxFlex="40">
            <mat-label>{{ 'CONTACTS.PHONE.NUMBER' | translate }}</mat-label>
            <input
              id="contact-phones-{{ index }}"
              [formControl]="contactPhone.get('number')"
              mask="(00) 0000-0000||(00) 0 0000-0000"
              matInput
              required
              autocomplete="tel"
            />
            <mat-error *ngIf="contactPhone.get('number').hasError('required')">
              {{ 'CONTACTS.PHONE.ERRORS.NUMBER_REQUIRED' | translate }}
            </mat-error>
            <mat-error
              *ngIf="
                contactPhone.get('number').hasError('phoneNumberDuplicated') &&
                !contactPhone.get('number').hasError('required')
              "
            >
              {{ 'CONTACTS.PHONE.ERRORS.NUMBER_DUPLICATED' | translate }}
            </mat-error>
            <mat-error
              *ngIf="
                contactPhone.get('number').hasError('mask') &&
                !contactPhone.get('number').hasError('required') &&
                !contactPhone.get('number').hasError('phoneNumberDuplicated')
              "
            >
              {{ 'LOCATIONS.ERRORS.PHONE_NUMBER_PATTERN' | translate }}
            </mat-error>
          </mat-form-field>

          <mat-form-field class="pl-4" appearance="legacy" fxFlex="28">
            <mat-label>{{ 'CONTACTS.PHONE.TYPE' | translate }}</mat-label>
            <mat-select [formControl]="contactPhone.get('contactType')" required>
              <mat-option value="work">
                {{ 'CONTACTS.PHONE.WORK' | translate }}
              </mat-option>
              <mat-option value="home">
                {{ 'CONTACTS.PHONE.HOME' | translate }}
              </mat-option>
              <mat-option value="cell">
                {{ 'CONTACTS.PHONE.CELL' | translate }}
              </mat-option>
            </mat-select>

            <mat-error *ngIf="contactPhone.get('contactType').hasError('required')">
              {{ 'CONTACTS.PHONE.ERRORS.TYPE_REQUIRED' | translate }}
            </mat-error>
          </mat-form-field>

          <mat-form-field class="pl-4" appearance="legacy" fxFlex="25">
            <mat-label> {{ 'CONTACTS.PHONE.NAME' | translate }}</mat-label>
            <input id="contact-phones-{{ index }}" [formControl]="contactPhone.get('name')" matInput />
          </mat-form-field>

          <div *ngIf="!isViewMode" class="remove-contact-field" (click)="removeContactItem('phones', index)">
            <mat-icon>delete</mat-icon>
          </div>
        </div>

        <div class="mt-5" fxLayout="row">
          <mat-slide-toggle
            (change)="changePrimaryContactItem('phones', index)"
            [formControl]="contactPhone.get('primary')"
          >
            {{ 'CONTACTS.PHONE.PRIMARY' | translate }}
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="!isViewMode && contactForm.get('phones')['controls'].length < 3"
    [ngClass]="{ 'add-more-contact-button': contactForm.get('phones')['controls'].length > 0 }"
    (click)="addNewContactItem('phones')"
    class="new-contact-button"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    matRipple
  >
    <div>
      <mat-icon class="new-contact-button-icon font-size-24">phone</mat-icon>
      <p class="h4 new-contact-button-text">{{ 'CONTACTS.ADD_PHONE' | translate }}</p>
    </div>
  </div>
</form>
